import { ButtonProps, DialogProps } from '@mui/material';
import { MutationKey, UseMutationResult } from '@tanstack/react-query';
import { createContext } from 'react';

type mutation = UseMutationResult<unknown, Error, void, unknown>;

export type openDialogProps = {
    title?: string;
    message?: string;
    content?: React.ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm?: () => any;
    confirmMutation?: mutation;
    confirmButtonProps?: ButtonProps;
    dialogProps?: Omit<DialogProps, 'open' | 'onClose'>;
    disableActions?: boolean;
    mutationKey?: MutationKey;
};

interface DialogContextType {
    open: (props: openDialogProps) => void;
    close: () => void;
    mutation?: mutation;
}

const DialogContext = createContext<DialogContextType>({
    open: () => {},
    close: () => {},
});

export default DialogContext;
